/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationLimitsDTO
 */
export interface OrganizationLimitsDTO {
    /**
     * 
     * @type {number}
     * @memberof OrganizationLimitsDTO
     */
    storageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLimitsDTO
     */
    privateProjectMembers?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLimitsDTO
     */
    projectsLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLimitsDTO
     */
    membersLimit?: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationLimitsDTO
     */
    expirationDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof OrganizationLimitsDTO
     */
    subscriptionHours?: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationLimitsDTO
     */
    isExpired: boolean;
}

/**
 * Check if a given object implements the OrganizationLimitsDTO interface.
 */
export function instanceOfOrganizationLimitsDTO(value: object): value is OrganizationLimitsDTO {
    if (!('isExpired' in value) || value['isExpired'] === undefined) return false;
    return true;
}

export function OrganizationLimitsDTOFromJSON(json: any): OrganizationLimitsDTO {
    return OrganizationLimitsDTOFromJSONTyped(json, false);
}

export function OrganizationLimitsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationLimitsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'storageSize': json['storageSize'] == null ? undefined : json['storageSize'],
        'privateProjectMembers': json['privateProjectMembers'] == null ? undefined : json['privateProjectMembers'],
        'projectsLimit': json['projectsLimit'] == null ? undefined : json['projectsLimit'],
        'membersLimit': json['membersLimit'] == null ? undefined : json['membersLimit'],
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'subscriptionHours': json['subscriptionHours'] == null ? undefined : json['subscriptionHours'],
        'isExpired': json['isExpired'],
    };
}

export function OrganizationLimitsDTOToJSON(value?: OrganizationLimitsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'storageSize': value['storageSize'],
        'privateProjectMembers': value['privateProjectMembers'],
        'projectsLimit': value['projectsLimit'],
        'membersLimit': value['membersLimit'],
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'subscriptionHours': value['subscriptionHours'],
        'isExpired': value['isExpired'],
    };
}

